import LocationMap from "./widgets/LocationMap";
import SearchBar from "./widgets/SearchBar";
import Carcategoryslider from "./widgets/Carcategoryslider";
import StationsList from "./widgets/StationList";
import VehicleList from "./widgets/VehicleList";
import ReservationButton from "./widgets/ReservationButton";

function App(props: any) {
  let content;

  switch (props.symbol) {
    case "locationmap":
      content = <LocationMap symbol={props.symbol} />;
      break;
    case "searchbar":
      content = <SearchBar symbol={props.symbol} />;
      break;
    case "carcategoryslider":
      content = <Carcategoryslider symbol={props.symbol} />;
      break;
    case "vehiclelist":
      content = (
        <VehicleList
          special={props.dataset.specialcar}
          showfilter={props.dataset.showfilter === "true" ? true : false}
          categorypreselect={props.dataset.categorypreselect}
          showdetails={props.dataset.showdetails === "true" ? true : false}
          singlecar={props.dataset.singlecar === "true" ? true : false}
          calcprice={props.dataset.calcprice === "true" ? true : false}
          singleimg={props.dataset.singleimg}
          hideFromFilter={
            props.dataset.hidefromfilter
              ? props.dataset.hidefromfilter.split(",")
              : []
          }
        />
      );
      break;
    case "stationlist":
      content = (
        <StationsList
          symbol={props.symbol}
          type={props.dataset.type}
          detailpage={props.dataset.detailpage}
          showfilter={props.dataset.showfilter === "true" ? true : false}
          showdetails={props.dataset.showdetails}
          stationid={props.dataset.stationid}
        />
      );
      break;
    case "reservationbutton":
      content = (
        <ReservationButton
          selectedcargroup={props.dataset.selectedcargroup}
          text={props.dataset.text}
          class={props.dataset.class}
        />
      );
      break;
    default:
      break;
  }

  return <div>{content}</div>;
}

export default App;
